$(document).on('click', '.not-clickable', function (e) {
    e.preventDefault();
    return false;
});

$(document).on('click', '.stop-propagation', function (e) {
    e.stopPropagation();
});